import React, { useState, useEffect } from "react";

// STYLES
import * as Style from "./PreviousEventsStyle";

// LIBRARIES

// MISC
import { eventsData } from "mocks/PreviousEventsMock";
import { ButtonTypes } from "models/GeneralTypes/generalTypes";

// ASSETS

// REDUX

// COMPONENTS
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import InputAtom from "components/Atoms/InputAtom/InputAtom";
import EventCard from "components/EventCard/EventCard";
import Pagination from "components/TablePagination/TablePagination";

const PreviousEvents = () => {
  // PROPS

  // CONSTANTS USING LIBRARIES

  // CONSTANTS USING HOOKS
  const [inputValue, setInputValue] = useState("");
  const [eventsList, setEventsList] = useState<any[]>(eventsData);
  const [currentPage, setCurrentPage] = useState(0);

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION
  useEffect(() => {
    if (inputValue.length > 0) {
      let filteredEvents = eventsData.filter((event) =>
        event.title.toLowerCase().includes(inputValue.toLowerCase())
      );
      setEventsList(filteredEvents);
    } else {
      setEventsList(eventsData);
    }
  }, [inputValue]);
  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleClearFilters = () => {
    setInputValue("");
    setEventsList(eventsData);
  };

  return (
    <Style.PreviousEventsContainer>
      <Style.Title>Istoric evenimente</Style.Title>
      <Style.SearchContainer>
        <Style.InputAtomContainer>
          <InputAtom
            placeholder="Cauta..."
            label="Cauta"
            inputValue={inputValue}
            setInputValue={setInputValue}
          />
        </Style.InputAtomContainer>
        <Style.ButtonAtomContainer>
          <ButtonAtom 
          text="Clear filters" 
          onClick={handleClearFilters}
          type={ButtonTypes.MAIN_BUTTON}
           />
        </Style.ButtonAtomContainer>
      </Style.SearchContainer>
      <Style.EventsContainer>
        {eventsList.map((eventDetails) => (
          <EventCard height="100%" eventDetails={eventDetails} />
        ))}
      </Style.EventsContainer>
      <Style.PaginationContainer>
        <Pagination
          onChange={(e, newPage) => setCurrentPage(newPage - 1)}
          currentPage={currentPage}
          totalPage={Math.ceil(eventsData.length / 8)}
        />
      </Style.PaginationContainer>
    </Style.PreviousEventsContainer>
  );
};

export default PreviousEvents;
